import React from 'react';
import { Col } from 'react-grid-system';
import useTranslate from '@Utils/hooks/useTranslate';
import Map from '@Components/Map/Map';
import Divider from '@Components/Divider/Divider';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import LabeledInformation from './LabeledInformation';
import { MapElement } from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';
import { IAddress } from '@ApiModels/commerceProfile';

interface IMapDetails {
	showMap?: boolean;
	selectedAddress: IAddress | undefined;
}

const MapDetails = ({ showMap, selectedAddress }: IMapDetails): JSX.Element => {
	const { translate } = useTranslate();

	return (
		<>
			{showMap && (
				<Col xs={12} sm={6}>
					<Map
						mapElement={<MapElement />}
						zoom={17}
						position={selectedAddress?.markerPosition}
						markerPosition={selectedAddress?.markerPosition}
						containerElement={<MapElement />}
						locked
					/>
				</Col>
			)}
			<Col sm={12} md={12}>
				<ConditionalRender
					show={!!selectedAddress?.landmark}
					onTrue={() => (
						<>
							<Divider withoutLine marginTop={40} />
							<LabeledInformation
								label={translate('shipping-details.billing.contact-data.data.landmark')}
								data={selectedAddress?.landmark}
							/>
						</>
					)}
				/>
			</Col>
		</>
	);
};

export default MapDetails;
